// extracted by mini-css-extract-plugin
module.exports = {"button":"GoogleLoginButton_button__fQ3as","buttonIcon":"GoogleLoginButton_buttonIcon__2p3Xo"};